// Only Grid (MLS Grid / ACTRIS) photos need the backend proxy — the browser can't set the
// User-Agent/bearer header Grid requires on an <img>. Spark (ARMLS) photos are PUBLIC/unsigned, so we
// load them DIRECT from the CDN: that's much faster than proxying every image through our single
// server, and the CDN handles caching. (The backend /api/photo still accepts Spark hosts — the
// server-side opportunity scorer fetches Spark photos through it for Claude vision.)
// Non-MLS URLs (e.g. picsum fallbacks, local thumbnails) are returned as-is.
// opts.thumb=true requests a small list-view thumbnail (the backend generates + serves a resized
// variant) instead of the full-resolution image — far less bandwidth for card/list grids.
export function proxyPhoto(url, opts) {
  if (!url) return url;
  if (typeof url !== 'string') return url;
  if (/^https:\/\/[A-Za-z0-9.-]+\.mlsgrid\.com\//.test(url)) {
    const q = opts && opts.thumb ? '&thumb=1' : '';
    return `/api/photo?url=${encodeURIComponent(url)}${q}`;
  }
  return url;
}

// Convenience: list-view thumbnail.
export function proxyThumb(url) {
  return proxyPhoto(url, { thumb: true });
}
